import Dashboard from "./pages/Dashboard";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import "./styles/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import DashboardTemplate from "./templates/DashboardTemplate";
import History from "./pages/History";
import RecordingPage from "./pages/RecordingPage";
import UserGuide from "./pages/UserGuide";
import React, { useEffect } from "react";
import { SERVER_BASE_URL } from "./config";
import { set_OrgIntegratedToZoho } from "./features/ConfigSlice";
import { API } from "./config/auth";
import { useDispatch } from "react-redux";
import { message } from "antd";

function App() {
  const dispatch = useDispatch();

  async function integrationWithZohoAPI(code, state) {
    const datacenter = new URLSearchParams(window.location.search).get("location");
    const body = {
      organization_id: state,
      update_type: "auth_details",
      updates: {
        auth_type: "ZOHO",
        auth_code: code,
        datacenter,
      },
    };
    try {
      const response = await API.patch(
        `${SERVER_BASE_URL}/organization/update_organization`,
        body
      );
      console.log("response", response.data);
      if (response.data?.success === false) {
        message.error("Please try again later!!");
        return;
      }
      window.localStorage.setItem("is_org_integrated_to_zoho", true);
      dispatch(set_OrgIntegratedToZoho(true));
      window.history.replaceState(null, "", window.location.pathname);
      window.location.hash = "#/jas";
    } catch (error) {
      console.error("Zoho integration failed:", error);
      message.error("Zoho integration failed. Please try again.");
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (code && state) {
      console.log("🔑 Zoho redirect detected:", { code, state });
      integrationWithZohoAPI(code, state);
    }
  }, []);

  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/recording" element={<RecordingPage />} />
          <Route path="/user-guide" element={<UserGuide />} />
          <Route
            path="/jas"
            element={
              <DashboardTemplate>
                <Dashboard />
              </DashboardTemplate>
            }
          />
          <Route
            path="/jas/history"
            element={
              <DashboardTemplate>
                <History />
              </DashboardTemplate>
            }
          />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
